//const BASE_URL = 'https://foodcomposition.catalystdemo.net.nz/api';


//const UAT_BASE_URL = 'https://api.uat.foodcomposition.co.nz/api';
const UAT_BASE_URL = 'https://api.foodcomposition.uat.pfr.co.nz/api';

const LIVE_BASE_URL = 'https://api.foodcomposition.co.nz/api';

const DEV_DOCKER_BASE_URL = 'http://localhost:8080/api';
const DEV_BASE_URL = 'http://localhost:8000/api';


// try to set the base url based on the hostname ZJG 20240829
var this_host = window.location.hostname;
var BASE_URL;

if(this_host.includes('localhost:8000')){
  BASE_URL = DEV_BASE_URL;
}else if(this_host.includes('localhost:8080')){
  BASE_URL = DEV_DOCKER_BASE_URL;
} else if(this_host.includes('foodcomposition') && this_host.includes("uat")){
  BASE_URL = UAT_BASE_URL;
} else if(this_host.includes('foodcomposition.co.nz')){
  BASE_URL = LIVE_BASE_URL;
} else {
  BASE_URL = LIVE_BASE_URL;
}



//const BASE_URL = LIVE_BASE_URL;

export default BASE_URL;



// WEBPACK FOOTER //
// ./src/components/apiAccess/urls.js